module.exports = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/3ff748eeae0f5f2f56c81d3b76445b7f.svg";